import React, { useEffect, useState } from "react";
import { Map, Download, IndianRupee, AlertTriangle } from "lucide-react";
import CustomHookForRuralDetails from "../../components/ruralDetailsCount/CustomHookForRuralDetails";
import { useDispatch, useSelector } from "react-redux";
import DynamicIcon from "../../components/Form/FormFields/DynamicIcon";
import DynamicLoader from "../../components/Form/FormFields/DynamicLoader";
import CustomModal from "../../components/ui/CustomModal";
import CustomTable from "../../components/ui/CustomTable";
import { RootState } from "../../utils/store/rootReducer";
import { setTableChartId } from "../../components/applicationStatus/store";
import Accordion from "../../components/ui/Accordion";

const Mapcard = ({ ...props }: any) => {
  const dispatch = useDispatch();
  const { ruralDetailsCount } = CustomHookForRuralDetails();
  const selector = useSelector((state: RootState) => state);
  const propsData = props?.chartListData;
  const selectorData = useSelector(
    (state: { dynamicData: DynamicData }) => state?.dynamicData
  );
  const selectCompontData =
    selector.chartListDetails?.componentData?.ALL?.[propsData?.id];
  const [popUpMapCard, setPopUpMapCard] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const rawData =
    useSelector((state) => state?.dynamicData?.[propsData?.id]) || [];

  const isLoading = selectorData.loaders?.[`report/chart/${[propsData?.id]}`];
  useEffect(() => {
    const mapData = async () => {
      await ruralDetailsCount(propsData?.id, props);
    };
    mapData();
  }, [propsData?.id]);

  const fetchPopupData = async (data: any, type) => {
    setIsModalOpen(true);
    return await ruralDetailsCount(selectCompontData?.popup_chart_id, props);
  };

  const count = propsData?.length || 1;

  // dynamic grid col class
  const gridColsClass = `grid-cols-${count > 4 ? 4 : count}`; // max 4 cols
  const gapClass = count > 2 ? "gap-4" : "gap-2";
  return (
    <>
      {isLoading ? (
        <DynamicLoader loading={isLoading} />
      ) : (
        <div className="p-4">
          <div className={`grid ${gridColsClass} ${gapClass}`}>
            <div
              className={`flex items-center justify-between px-6 py-4 rounded-xl shadow-sm ${propsData?.color}`}
            >
              {/* Left: Value + Label */}
              <div>
                <div className="text-2xl font-semibold text-[#3F4254]">
                  <span
                    className="cursor-pointer hover:underline"
                    onClick={async () => {
                      // await dispatch(setTableChartId("hasPopup"));
                      // setPopUpMapCard(true);

                      propsData?.has_popup &&
                        fetchPopupData(propsData.popup_chart_id, "district");
                    }}
                  >
                    {Number(rawData[0]?.value).toLocaleString("en-IN")}
                  </span>
                </div>
                <div className="text-sm text-[#6B7280]">{propsData.title}</div>
              </div>

              <div className="flex items-center gap-2">
                <DynamicIcon name={propsData?.icon} />
              </div>
            </div>
          </div>
        </div>
      )}
      <CustomModal
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        title="Map Details"
        size={propsData?.size || "xl"}
      >
        <div>
          <CustomTable
            columns={selectorData?.[selectCompontData?.popup_chart_id]?.columns}
            rows={selectorData[selectCompontData?.popup_chart_id]?.rows}
            title="Map Details"
            hideTitle={true}
            isLoading={
              selectorData.loaders[
                `report/chart/${selectCompontData?.popup_chart_id}`
              ]
            }
          />
        </div>
      </CustomModal>
    </>
  );
};

export default Mapcard;
